<template>
  <card-dialog
    v-model="modalVisible"
    max-width="600px"
    :title="'Flash ' + playerIds.length + ' players'"
  >
    <v-card-text
      class="pa-6"
    >
      <validation-observer ref="validation">
        <v-card
          class="elevation-10"
          rounded="lg"
          outlined
        >
          <v-card-title
            class="clickable no-gutters"
            :class="{ 'v-btn--disabled': action.format }"
            @click="action.update = !action.update"
          >
            <v-col class="body-1 font-weight-medium">
              Update firmware
            </v-col>
            <v-col cols="auto">
              <v-switch
                v-model="action.update"
                hide-details
                class="pa-0 ma-0"
                :disabled="action.format"
                @click.stop.prevent
              />
            </v-col>
          </v-card-title>
          <v-expand-transition>
            <v-card-text v-if="action.update">
              <p class="body-2">
                Player firmware will be downloaded and replaced.
              </p>

              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  v-model="firmwareId"
                  :items="firmware.data"
                  outlined
                  label="Select firmware version"
                  item-value="id"
                  item-text="version"
                  :error-messages="errors"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.version }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.description }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="caption">
                      {{ $dayjs(item.created_at).format('DD.MM.YYYY.') }}
                    </v-list-item-action>
                  </template>
                </v-select>
              </validation-provider>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <v-card
          class="elevation-10 mt-4"
          rounded="lg"
          outlined
        >
          <v-card-title
            class="clickable no-gutters"
            :class="{ 'v-btn--disabled': action.format }"
            @click="action.resetConfig = !action.resetConfig"
          >
            <v-col class="body-1 font-weight-medium">
              Reset configuration
            </v-col>
            <v-col cols="auto">
              <v-switch
                v-model="action.resetConfig"
                hide-details
                class="pa-0 ma-0"
                :disabled="action.format"
                @click.stop.prevent
              />
            </v-col>
          </v-card-title>
          <v-expand-transition>
            <v-card-text v-if="action.resetConfig">
              <p class="body-2">
                Configuration will be cleared. This includes player configuration, clock schedules. Media will not be deleted.
              </p>
            </v-card-text>
          </v-expand-transition>
        </v-card>

        <!--        <v-card-->
        <!--          class="elevation-10 mt-4"-->
        <!--          rounded="lg"-->
        <!--          outlined-->
        <!--        >-->
        <!--          <v-card-title-->
        <!--            class="clickable no-gutters"-->
        <!--            @click="action.resetMedia = !action.resetMedia"-->
        <!--          >-->
        <!--            <v-col class="body-1 font-weight-medium">-->
        <!--              Reset media-->
        <!--            </v-col>-->
        <!--            <v-col cols="auto">-->
        <!--              <v-switch-->
        <!--                v-model="action.resetMedia"-->
        <!--                hide-details-->
        <!--                class="pa-0 ma-0"-->
        <!--                @click.stop.prevent-->
        <!--              />-->
        <!--            </v-col>-->
        <!--          </v-card-title>-->
        <!--          <v-expand-transition>-->
        <!--            <v-card-text v-if="action.resetMedia">-->
        <!--              <p class="body-2">-->
        <!--                All media will be deleted, including songs, advertisements and public announcements.-->
        <!--              </p>-->
        <!--            </v-card-text>-->
        <!--          </v-expand-transition>-->
        <!--        </v-card>-->

        <v-card
          class="elevation-10 mt-4"
          rounded="lg"
          outlined
        >
          <v-card-title
            class="clickable no-gutters"
            @click="action.format = !action.format"
          >
            <v-col class="body-1 font-weight-medium">
              Format
            </v-col>
            <v-col cols="auto">
              <v-switch
                v-model="action.format"
                hide-details
                class="pa-0 ma-0"
                @click.stop.prevent
              />
            </v-col>
          </v-card-title>
          <v-expand-transition>
            <v-card-text v-if="action.format">
              <p class="body-2">
                All player storage will be formatted, including media, configuration, temporary files and other, new firmware will be downloaded and installed.
              </p>
            </v-card-text>
          </v-expand-transition>
        </v-card>
      </validation-observer>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="primary"
          :loading="submitting"
          :disabled="!action.update && !action.resetConfig && !action.format"
          @click="submit()"
        >
          Start flash
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import Players from '@/services/Players'
import Firmware from '@/services/Firmware'

export default {
  name: 'FlashDialog',
  components: { CardDialog },
  mixins: [deleteConfirmationMixin],
  props: {
    playerIds: {
      type: Array,
      default: () => ([])
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      firmware: {
        loading: false,
        data: []
      },
      action: {
        update: false,
        format: false,
        resetConfig: false
      },
      firmwareId: undefined
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  watch: {
    'action.format': function (value) {
      if (value) {
        this.action.update = true
        this.action.resetConfig = true
      }
    }
  },
  created() {
    this.fetchFirmware()
  },
  methods: {
    async fetchFirmware() {
      this.firmware.loading = true

      try {
        this.firmware.data = (await Firmware.fetch())
      } catch (e) {

      } finally {
        this.firmware.loading = false
      }
    },
    async submit() {
      if (!(await this.$refs.validation.validate())) {
        return
      }

      await this.save()
    },
    async save() {
      try {
        this.submitting = true

        let action

        if (this.action.format) action = 'format'
        else if (this.action.update && !this.action.resetConfig) action = 'update'
        else if (this.action.update && this.action.resetConfig) action = 'update_reset_overlay'
        else if (!this.action.update && this.action.resetConfig) action = 'reset_overlay'
        else return

        const data = {
          player_ids: this.playerIds,
          action,
          firmware_id: action === 'update' || action === 'update_reset_overlay' || action === 'format' ? this.firmwareId : undefined
        }

        const result = await Players.flash(data)

        this.$emit('player:flashed', result)

        this.$store.dispatch('alert', {
          text: 'Successfully sent flash request',
          color: 'success'
        })

        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There were some errors submitting flash request',
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
